export default __webpack_public_path__ + "static/media/featuresAndJoin.5787fdf2.png";